import React, { FC } from 'react';

import { UIContextProvider } from './UIContext/UIContextProvider';
import { TemplateContextProvider } from './TemplateContext/TemplateContextProvider';
import { StoreTemplate } from './TemplateContext/TemplateContext';
import { ConfigContextProvider } from './ConfigContext/ConfigContextProvider';
import { ConfigContextShape } from './ConfigContext/ConfigContext';
import { ExperimentContextProvider } from './ExperimentContext/ExperimentContextProvider';
import { UserData } from './UserDataContext/UserDataContext';
import { UserDataContextProvider } from './UserDataContext/UserDataContextProvider';

export type StoreInitialState = {
  template: StoreTemplate;
  config: ConfigContextShape;
  activeExperiments: string[];
  userData: UserData;
};

export const ContextProvider: FC<{ initialState: StoreInitialState }> = ({ initialState, children }) => (
  <TemplateContextProvider initialState={{ template: initialState.template }}>
    <ExperimentContextProvider initialState={{ activeExperiments: initialState.activeExperiments }}>
      <UIContextProvider>
        <UserDataContextProvider initialState={{ userData: initialState.userData }}>
          <ConfigContextProvider initialState={{ config: initialState.config }}>{children}</ConfigContextProvider>
        </UserDataContextProvider>
      </UIContextProvider>
    </ExperimentContextProvider>
  </TemplateContextProvider>
);
